/**
 * Validates coordinates (latitude and longitude) to ensure they are valid
 * numbers within acceptable ranges.
 *
 * @param {number | string} lat - Latitude value to validate
 * @param {number | string} lon - Longitude value to validate
 * @param {string} [source] - Optional source identifier for logging
 * @returns {Object | null} Object with validated lat/lon or null if invalid
 */
export const validateCoordinates = (lat, lon, source = 'unknown') => {
  // Convert to numbers if they're strings
  const numLat = typeof lat === 'string' ? parseFloat(lat) : lat
  const numLon = typeof lon === 'string' ? parseFloat(lon) : lon

  // Check if values are valid numbers
  const isValidLat = !isNaN(numLat) && numLat >= -90 && numLat <= 90
  const isValidLon = !isNaN(numLon) && numLon >= -180 && numLon <= 180

  // Both coordinates must be valid
  if (!isValidLat || !isValidLon) {
    console.warn(
      `Invalid coordinates detected in ${source}: lat=${lat}, lon=${lon}`,
    )
    return null
  }

  // Return validated coordinates
  return {
    lat: numLat,
    lon: numLon,
  }
}
